// VideosList.jsx
import React from "react";
import { Stack, Typography } from "@mui/material";
import { VideoCard } from "./VideoCard";

export const VideosList = ({ videos, onVideoSelect, loading, moreVideosText }) => {
  const shouldShowHeader = Boolean(moreVideosText);
  const hasVideos = Array.isArray(videos) && videos.length > 0;

  if (!loading && !hasVideos && !shouldShowHeader) return null;

  return (
    <Stack sx={{ mt: 1.5, backgroundColor: shouldShowHeader ? "lightgray" : "transparent" }} spacing={1}>
      {shouldShowHeader && (
        <Typography variant="body1" sx={{ pb: 0,  p: 1 }} >
          {moreVideosText}
        </Typography>
      )}
      <div
        style={{
          maxHeight: "150px",
          overflow: "scroll"
        }}>
        {loading ? (
          <Typography sx={{ p: 2 }}>Loading...</Typography>
        ) : (
          videos?.map((video, index) => (
            <VideoCard
              key={video.id || index}
              video={video}
              onClick={() => onVideoSelect(video)}
            />
          ))
        )}
      </div>
    </Stack>
  );
};
